import React from 'react';
import { Button, Col, Row } from '@oscar/theme';
import { TextField } from 'common/components';
import { Notification } from './index';
import { DetailedFormProps } from 'common/components/FormList/types';
import { SAP_STATUS_LIST } from 'common/constants/insulation';
import { FORMAT_DATE } from 'common/constants';
import useStatus from 'views/pages/create-instrulation/hooks/useStatus';
import { useAuth } from 'features/auth';
import { AsyncField, useFormContext } from '@oscar/form';
import { APIS } from 'common/constants/endpoints';
import { isObject } from 'lodash';
import { useDeepCompareEffect } from '@oscar/utils';

export const SearchResult = (props: DetailedFormProps<Notification>) => {
  const { addItem, item, field, readOnly, removeItem, resetItem, notAllowAdd } =
    props;
  const [formContext] = useFormContext();
  const [statusRequest] = useStatus();
  const [auth] = useAuth();

  const listWorkDetail = formContext.form?.getFieldValue('listWorkDetail');

  useDeepCompareEffect(() => {
    if (listWorkDetail && listWorkDetail.length >= 0) {
      formContext?.form?.setFieldsValue({ isWorkDetailRequire: true });
    }
  }, [listWorkDetail?.length]);

  return (
    <div className="notification-detail">
      {!readOnly && (
        <div className="notification-detail-title">Search Result</div>
      )}
      <div className="notification-detail-content">
        {item ? (
          item?.isLocal ? (
            <div className="notification-detail-content-placeholder warning">
              {item?.isLocal && <div>No Notification ID found</div>}
            </div>
          ) : (
            <div>
              <Row gutter={12}>
                <Col span={24}>
                  <div className="search-header">
                    <div className="search-header_id">
                      <TextField
                        label="Notification ID"
                        value={
                          item?.saP_NotificationId
                            ? item?.saP_NotificationId
                            : '<Auto-generated>'
                        }
                      />
                    </div>
                    {!field && item && (
                      <div>
                        <Button
                          className="add-to-list-button"
                          onClick={() => {
                            resetItem?.();
                          }}
                        >
                          Reset
                        </Button>
                        <Button
                          type="primary"
                          className="add-to-list-button"
                          disabled={notAllowAdd}
                          onClick={() => addItem?.(item)}
                        >
                          Add to list
                        </Button>
                      </div>
                    )}
                    {field &&
                      statusRequest?.state === 'EDIT' &&
                      (auth.getUserRoles().includes('OSCAR') ||
                        (auth.getUserRoles().includes('PAINTING') &&
                          statusRequest?.type === 'PAINTING') ||
                        (auth.getUserRoles().includes('INSULATION') &&
                          statusRequest?.type &&
                          ['INSTATEMENT', 'REMOVAL'].includes(
                            statusRequest.type,
                          ))) && (
                        <Button
                          type="primary"
                          className="update-button"
                          onClick={() => {
                            removeItem?.(field);
                          }}
                          size="small"
                        >
                          Remove from list
                        </Button>
                      )}
                  </div>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={24}>
                  <TextField
                    label="Status"
                    value={item?.saP_Status}
                    mappingData={SAP_STATUS_LIST}
                    primary
                  />
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={24}>
                  <TextField
                    label="Job Description"
                    value={item?.saP_JobDescription}
                  />
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={12}>
                  <div className="result-list">
                    <AsyncField
                      name={'fetchLocation'}
                      requests={[
                        {
                          name: 'location',
                          url: `${
                            APIS.SEARCH_LOCATION_BY_ID
                          }?functionalLocationId=${
                            item?.saP_FunctionalLocation || ''
                          }`,
                          shouldRequest: () => {
                            if (item?.saP_FunctionalLocation) {
                              return true;
                            }
                            return false;
                          },
                          method: 'GET',
                        },
                      ]}
                    >
                      {(locationProps: any) => {
                        let value = '';
                        if (isObject(locationProps?.data?.location)) {
                          value =
                            locationProps?.data?.location?.functionalLocation;
                        }
                        if (!item?.saP_FunctionalLocation) {
                          value = '';
                        }
                        return (
                          <TextField
                            label="Functional Location"
                            value={value}
                          />
                        );
                      }}
                    </AsyncField>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="result-list">
                    <TextField
                      label="Location Description"
                      value={item?.saP_LocationDescription}
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={12}>
                  <TextField label="Priority" value={item?.saP_Priority} />
                </Col>
                <Col span={12}>
                  <TextField
                    label="Maintenance Order"
                    value={item?.saP_MaintenanceOrder}
                  />
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={12}>
                  <TextField
                    label="Start Date"
                    value={item?.saP_StartDate}
                    isDate
                    formartDate={FORMAT_DATE.SHORT_MONTH_DATE}
                  />
                </Col>
              </Row>
            </div>
          )
        ) : (
          <div className={'notification-detail-content-placeholder'}>
            Notification details from the search result
          </div>
        )}
      </div>
    </div>
  );
};
